import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import { checkSelfBanned } from "@/lib/moderation";

/**
 * Server-checked ban status for the signed-in user. Read on auth changes.
 * Returns { banned, ready } so callers can decide whether to render the suspension screen.
 */
export const useBanGuard = () => {
  const { user, authReady } = useAuth();
  const [banned, setBanned] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let cancelled = false;
    if (!authReady) return;
    if (!user) {
      setBanned(false);
      setReady(true);
      return;
    }
    setReady(false);
    void checkSelfBanned().then((b) => {
      if (!cancelled) {
        setBanned(b);
        setReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [user?.id, authReady]);

  return { banned, ready };
};
